import React from "react";
import {
  ChefHat, BookOpen, Palette, Home, Briefcase, Sparkles, Camera, House,
  Tag,
} from "lucide-react";

const ICONS = {
  ChefHat, BookOpen, Palette, Home, Briefcase, Sparkles, Sparkle: Sparkles,
  Camera, House,
};

/**
 * Renders the Lucide icon that matches the category's `icon` field
 * (populated from seed_data.py). Falls back to <Tag /> if unknown.
 */
export default function CategoryIcon({ name, size = 20, className = "" }) {
  const Cmp = ICONS[name] || Tag;
  return <Cmp size={size} className={className} strokeWidth={1.75} />;
}
